import { render, staticRenderFns } from "./ConfigurationProvisionCategoriesCard.vue?vue&type=template&id=6e155b98&"
import script from "./ConfigurationProvisionCategoriesCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationProvisionCategoriesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports